// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

const buttonSizeVariants = {
    small: {
        height: 28,
        fontSize: 16,
        padding: "0 20px",
        icon: 10,
        iconPadding: 4,
        lineHeight: "19px",
    },
    medium: {
        height: 36,
        fontSize: 16,
        padding: "0 20px",
        icon: 12,
        iconPadding: 5,
        lineHeight: "19px",
    },
    large: {
        height: 43,
        fontSize: 18,
        padding: "0 24px",
        icon: 14,
        iconPadding: 6,
        lineHeight: "22px",
    },
};

export default buttonSizeVariants;
